import React from "react";
import { useTranslation } from "react-i18next";

const LOGO = (id) => `https://media.api-sports.io/football/leagues/${id}.png`;

// Leagues covered by HitMax (API-Football league ids)
const COMPETITIONS = [
  { id: 61, name: "Ligue 1" },
  { id: 39, name: "Premier League" },
  { id: 140, name: "La Liga" },
  { id: 2, name: "Champions League" },
  { id: 3, name: "Europa League" },
  { id: 62, name: "Ligue 2" },
  { id: 88, name: "Eredivisie" },
];

const Logo = ({ c }) => (
  <img
    src={LOGO(c.id)}
    alt={c.name}
    title={c.name}
    decoding="async"
    width="54"
    data-testid={`comp-logo-${c.id}`}
    onError={(e) => { e.currentTarget.style.display = "none"; }}
    className="h-[48px] sm:h-[54px] w-[52px] sm:w-[58px] mx-7 shrink-0 object-contain opacity-70 transition-all duration-300 hover:opacity-100 hover:scale-110"
    style={{ filter: "brightness(0) invert(1)" }}
  />
);

export const CompetitionsMarquee = () => {
  const { t } = useTranslation();
  const loop = [...COMPETITIONS, ...COMPETITIONS];
  return (
    <div className="w-full mt-2" data-testid="competitions-marquee">
      <p className="text-center text-[11px] uppercase tracking-[0.22em] text-white font-semibold mb-6">
        {t("marquee.title")}
      </p>
      <div className="hm-marquee-mask overflow-hidden">
        <div className="hm-marquee-track items-center">
          {loop.map((c, i) => (
            <Logo key={i} c={c} />
          ))}
        </div>
      </div>
    </div>
  );
};
